import { useEffect } from 'react';
import type { SectionPickerClickPayload } from './sectionPicker.types';

/**
 * Listens for postMessage events from the section picker iframe
 * and invokes the callback when an element is clicked.
 */
export function useIframePickerMessages(
  onElementClick: (payload: SectionPickerClickPayload) => void,
) {
  useEffect(() => {
    function handleMessage(event: MessageEvent<unknown>) {
      // Only accept messages from sandboxed iframes (opaque origin = "null").
      // The picker iframe uses sandbox="allow-scripts" without allow-same-origin
      // (to bypass CSP), which gives it this opaque origin.
      if (event.origin !== 'null') return;
      const data = event.data as Record<string, unknown> | null;
      if (data && data.type === 'SECTION_PICKER_CLICK') {
        onElementClick(data.payload as SectionPickerClickPayload);
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onElementClick]);
}
